import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Parcel1Kg: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.864 80.601L206.833 62.48 149.136 34 48.166 51.753 105.865 80.6z" fill="#FDDE84" />
    <path opacity=".4" d="M81.084 68.026l100.969-17.753-9.616-4.808-101.34 18.123 9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l-57.697-28.848v-53.26l57.697 28.85z" fill="#C39000" />
    <path opacity=".4" d="M81.084 68.026v19.972l-9.987-5.178V63.588l9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l100.969-18.493V62.478L105.864 80.602z" fill="#FCCE09" />
    <path
      d="M216.6 98.8c0-1.8-4.4-3.3-9.8-3.3S197 97 197 98.8v20.5c0 1.8 4.4 3.3 9.8 3.3s9.8-1.5 9.8-3.3V98.8z"
      fill="#6D6D6D"
    />
    <path
      d="M216.6 119.3V98.8c0 .8-.9 1.6-2.4 2.1v20.5c1.6-.5 2.4-1.3 2.4-2.1zM206.8 102c-5.4 0-9.8-1.5-9.8-3.3v20.6c0 1.8 4.4 3.3 9.8 3.3h1.6v-20.5c-.5-.1-1-.1-1.6-.1z"
      fill="#6D6D6D"
    />
    <path
      d="M206.8 102.1c5.412 0 9.8-1.477 9.8-3.3 0-1.822-4.388-3.3-9.8-3.3-5.412 0-9.8 1.478-9.8 3.3 0 1.823 4.388 3.3 9.8 3.3z"
      fill="#C8C8C8"
    />
    <path
      opacity=".05"
      d="M206.9 100.3c2.982 0 5.4-.806 5.4-1.8s-2.418-1.8-5.4-1.8-5.4.806-5.4 1.8 2.418 1.8 5.4 1.8z"
      fill="#000"
    />
    <path
      d="M208.4 98.6v-3.3c0-.3-.7-.5-1.6-.5-.9 0-1.6.2-1.6.5v3.3c0 .1.1.1.1.2.2.2.8.4 1.4.4.5 0 .9-.1 1.2-.2.1 0 .1 0 .1-.1h.1s.1 0 .1-.1l.2-.2c0 .1 0 .1 0 0z"
      fill="#555"
    />
    <path
      d="M212.3 91.8c0-1-2.4-1.8-5.4-1.8-3 0-5.4.8-5.4 1.8v3.1c0 1 2.4 1.8 5.4 1.8 3 0 5.4-.8 5.4-1.8v-3.1z"
      fill="#6D6D6D"
    />
    <path
      opacity=".1"
      d="M212.3 91.8c0-1-2.4-1.8-5.4-1.8-3 0-5.4.8-5.4 1.8v3.1c0 1 2.4 1.8 5.4 1.8 3 0 5.4-.8 5.4-1.8v-3.1z"
      fill="#fff"
    />
    <path
      d="M212.3 94.8v-3.1c0 .4-.5.9-1.3 1.1v3.1c.8-.2 1.3-.6 1.3-1.1zM206.9 93.6c-3 0-5.4-.8-5.4-1.8v3.1c0 1 2.4 1.8 5.4 1.8h.9v-3.1h-.9z"
      fill="#6D6D6D"
    />
    <path
      d="M206.9 93.6c2.982 0 5.4-.806 5.4-1.8s-2.418-1.8-5.4-1.8-5.4.806-5.4 1.8 2.418 1.8 5.4 1.8z"
      fill="#C8C8C8"
    />
    <path
      d="M206.9 112.3v-1.6h1.2v-3.9h-1.3v-1.6c1.4.1 2.2.1 3.5-.1v5.5c.5-.1.7-.1 1.2-.2v1.6c-1.7.3-2.8.3-4.6.3zM205.2 118.6v-4.3c.5.1.7.1 1.3.1v1.7h.3c.4-.6.6-1 1-1.6.6 0 .9 0 1.5-.1-.6.9-.9 1.3-1.4 2.2.6.9.9 1.3 1.5 2.1-.6.1-.9.1-1.6.1-.4-.7-.7-1-1.1-1.7h-.2v1.7c-.6-.1-.8-.1-1.3-.2zM211.4 118.5c-.6.1-1.1 0-1.4-.3-.3-.3-.5-.8-.5-1.5v-.4c0-.4.1-.8.3-1.1.2-.3.4-.6.7-.8.3-.2.6-.4 1-.4.6-.2 1-.1 1.3.1-.2.4-.3.6-.6 1-.1-.1-.2-.1-.3-.2h-.4c-.2.1-.4.2-.6.4-.1.2-.2.5-.2.9v.3c0 .4 0 .7.2.8.1.2.3.2.5.2.2-.1.4-.2.4-.3.1-.2.1-.4.2-.6-.3.1-.4.1-.7.2v-.9c.7-.2 1.1-.3 1.6-.6v.8c0 .6-.1 1.1-.4 1.6-.2.3-.6.6-1.1.8z"
      fill="#D3D1D1"
    />
    <path opacity=".2" d="M214.3 121.4v-20.5c-1.5.6-3.4 1-5.9 1.1v20.5c2.5-.1 4.4-.4 5.9-1.1z" fill="#fff" />
  </SvgIcon>
)
